import React from 'react';

import CookieListItem from '@components/CookieBanner/V3/CookieListItem';

import styles from './cookieList.scss';

interface CookieListProps {
  items: {
    id: string;
    properties?: {
      duration: string;
      provider: string;
      purpose: string;
      type: string;
    };
  }[];
}

const CookieList = ({
  items
}: CookieListProps) => (
  <div className={styles.details}>
    {items.map(({ id, properties }) => (
      <CookieListItem key={id} id={id} properties={properties} />
    ))}
  </div>
);

export default CookieList;
